export const validationProfileChangePassword = {
  type: 'object',
  properties: {
    old_password:           { type: "string" },    
    password:               { type: "string" },
    password_validate:      { type: "string" },
  },
  required: ['old_password', 'password', 'password_validate'],
};


export const validationProfileSupport = {
  type: 'object',
  properties: {
    type:         { type: "string"  },    
    title:        { type: "string", maxLength: 100 },
    message:      { type: "string", maxLength: 1000 },
  },
  required: ['type', 'title', 'message'],
};